import { ALERT_NOTIFICATION_METHODS } from "static/constants";
import { validateEmail } from "utils/common";
import * as Yup from "yup";

/**
 * Validation schema rule for alert configurations
 */
export const AlertConfigurationSchema = Yup.object().shape({
  configurations: Yup.array().of(
    Yup.object().shape({
      alert_type: Yup.string()
        .label("Alert Type")
        .required("Alert Type is required.")
        .oneOf(["red", "yellow"], "Alert Type should be one of red or yellow."),
      notify_configs: Yup.array().of(
        Yup.object().shape({
          active: Yup.boolean().label("Active"),
          time_period: Yup.string()
            .label("Time Period")
            .required("Time Period is required.")
            .oneOf(
              ["regular", "after_hours"],
              "Time Period should be one of regular or after hours."
            ),
          notification_method: Yup.string()
            .label("Notification Method")
            .required("Notification Method is required.")
            .typeError("Notification Method must be string."),
          recipients: Yup.array()
            .of(Yup.string().label("Recipient"))
            .label("Recipients")
            .when(["active", "notification_method"], {
              is: (active, notification_method) =>
                active === true &&
                notification_method === ALERT_NOTIFICATION_METHODS.email,
              then: (schema) =>
                schema
                  .min(1, "At least one recipient is required.")
                  .required("Recipients are required.")
                  .test(
                    "unique-recipient",
                    "Duplicate recipient/s found.",
                    (recipients) => {
                      const uniqueRecipients = new Set(recipients);
                      return uniqueRecipients.size === recipients.length;
                    }
                  )
                  .test(
                    "invalid-email",
                    "Invalid recipient email/s.",
                    (recipients) => {
                      return recipients.every((email) => validateEmail(email));
                    }
                  ),
              otherwise: (schema) => schema,
            }),
          message_content: Yup.array()
            .of(
              Yup.object().shape({
                title: Yup.string().label("Title"),
                free_text: Yup.string().label("Free Text"),
              })
            )
            .label("Message Content")
            .when("active", {
              is: true,
              then: (schema) =>
                schema.min(1, "At least one message content is required."),
              otherwise: (schema) => schema,
            })
            .required("Message Contents are required."),
        })
      ),
    })
  ),
});
